var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17582 11.2904L10.6625 8.80377V19.956C10.6625 20.4835 11.0392 20.8603 11.5667 20.8603H12.471C12.9608 20.8603 13.3752 20.4835 13.3752 19.956V8.80377L15.8242 11.2904C16.1633 11.6295 16.7661 11.6295 17.1052 11.2904L17.7457 10.6499C18.0848 10.3108 18.0848 9.70801 17.7457 9.36892L12.6217 4.28257C12.2826 3.90581 11.7174 3.90581 11.3783 4.28257L6.25432 9.36892C5.91523 9.70801 5.91523 10.3108 6.25432 10.6499L6.89482 11.2904C7.23391 11.6295 7.83673 11.6295 8.17582 11.2904Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.9a7abdca067d0b04c1cbffdea6c0ac3a.svg";
export { ForwardRef as ReactComponent };